
        
    const runtime = require("../../../../../../../node_modules/simple-nunjucks-loader/lib/cjs/runtime.js");
    
    const __nunjucks_module_dependencies__ = {};
    
    __nunjucks_module_dependencies__.templates = {};
    __nunjucks_module_dependencies__.globals = {};
    __nunjucks_module_dependencies__.extensions = {};
    __nunjucks_module_dependencies__.filters = {};
    __nunjucks_module_dependencies__.assets = {};
    
    
    
    
    
            const __nunjucks_template_import__filter_t = require("../../../nunjucks/t.js");
            __nunjucks_module_dependencies__.filters['t'] = {
                module: __nunjucks_template_import__filter_t && __nunjucks_template_import__filter_t.default || __nunjucks_template_import__filter_t,
                async: false
            };
    
        
            __nunjucks_module_dependencies__.templates["discussion/views/templates/response-list.html"] = (function() {
                function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "isShowingResponse")) {
output += "\n<div class=\"alert alert-info\">\n  ";
output += runtime.suppressValue(env.getFilter("t").call(context, "","discussion.response_list.alert"), env.opts.autoescape);
output += ".\n  <a href=\"#\" class=\"response-action-view-all\"\n    >";
output += runtime.suppressValue(env.getFilter("t").call(context, "","discussion.response_list.view_replies"), env.opts.autoescape);
output += "→</a\n  >\n</div>\n";
;
}
output += "\n<div class=\"response-filter-container\"></div>\n<a\n  href=\"#\"\n  class=\"paginate previous\"\n  data-action=\"previous\"\n  rv-show=\"state:has_previous\"\n>\n  <span rv-hide=\"state:paginating\"\n    >";
output += runtime.suppressValue(env.getFilter("t").call(context, "","discussion.response_list.load_previous",{"prev": "{\n    state:previous_count }"}), env.opts.autoescape);
output += "</span\n  >\n  <span rv-show=\"state:paginating\"\n    >";
output += runtime.suppressValue(env.getFilter("t").call(context, "","discussion.response_list.loading"), env.opts.autoescape);
output += "...</span\n  >\n</a>\n<div class=\"response-list-item-container\"></div>\n<a href=\"#\" class=\"paginate next\" data-action=\"next\" rv-show=\"state:has_next\">\n  <span rv-hide=\"state:paginating\"\n    >";
output += runtime.suppressValue(env.getFilter("t").call(context, "","discussion.response_list.load_more",{"next": "{ state:next_count\n    }"}), env.opts.autoescape);
output += "</span\n  >\n  <span rv-show=\"state:paginating\"\n    >";
output += runtime.suppressValue(env.getFilter("t").call(context, "","discussion.response_list.loading"), env.opts.autoescape);
output += "...</span\n  >\n</a>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

            })();
        

        function nunjucksTemplate(ctx = {}) {
            const templateContext = {
                __nunjucks_loader_assets__: __nunjucks_module_dependencies__.assets,
                ...ctx
            };

            var nunjucks = (runtime && runtime.default || runtime)(
                {"dev":false,"jinjaCompat":false,"isAsyncTemplate":false},
                __nunjucks_module_dependencies__
            );

            if (nunjucks.isAsync()) {
                return nunjucks.renderAsync(
                    "discussion/views/templates/response-list.html",
                    templateContext
                );
            }
        
            return nunjucks.render(
                "discussion/views/templates/response-list.html",
                templateContext
            );
        };

        nunjucksTemplate.__nunjucks_precompiled_template__ = __nunjucks_module_dependencies__.templates["discussion/views/templates/response-list.html"];
        nunjucksTemplate.__nunjucks_module_dependencies__ = __nunjucks_module_dependencies__;

        exports = module.exports = nunjucksTemplate;
    